import { Link } from 'react-router-dom';
import { SITE } from '~/content/site.js';

/**
 * The studio mark, reused from the main site (see the README for attribution),
 * with a `/ Careers` qualifier so this site is never mistaken for tekabsurd.com.
 *
 * Below 400px the header cannot hold the wordmark, the theme control and the
 * menu button at once, so the mark carries the brand there and the name stays
 * available to assistive technology.
 */
export function Logo() {
  return (
    <Link to="/" className="flex min-w-0 items-center gap-2.5 sm:gap-3">
      <img src="/logo.svg" width="44" height="44" alt="" className="size-8 shrink-0 sm:size-9" />
      <span className="hidden items-baseline gap-1.5 whitespace-nowrap min-[400px]:flex">
        <span className="font-heading text-base font-semibold tracking-[-0.04em] text-heading sm:text-lg">
          {SITE.companyName}
          <span className="text-primary">.</span>
        </span>
        <span className="hidden text-sm tracking-tight text-muted min-[480px]:inline">
          / {SITE.careersName}
        </span>
      </span>
      <span className="sr-only">
        {SITE.companyName} {SITE.careersName.toLowerCase()}, home
      </span>
    </Link>
  );
}
